/** 샵관리 — 매출현황 (조회 전용). 환불 건은 합계에서 제외 */
import React from 'react';
import { hiCol } from 'components/grid/hiGrid';
import ShopGridPage from './ShopGridPage';
import { loadTable, customerOptions, PAY_METHOD_OPTIONS, SALE_TYPE_OPTIONS } from 'shop/shopStore';
import { selectField, dateRangeFields, inRange } from 'shop/shopPageHelpers';

const label = (opts, v) => opts.find((o) => o.value === v)?.label || v || '';

const cfg = {
  gridId: 'sh-sale-report',
  title: '매출현황',
  uidKey: 'saleUid',
  readOnly: true,
  searchDefaults: { fromDate: '', toDate: '', saleType: '', customerUid: '' },
  searchFields: ({ tc }) => [[
    ...dateRangeFields(),
    selectField('customerUid', '고객', customerOptions(tc), '200px'),
    selectField('saleType', '구분', SALE_TYPE_OPTIONS),
  ]],
  columns: () => [
    hiCol.roTextColumn({ header: '매출일자', field: 'saleDate', size: 110, align: 'center' }),
    hiCol.roTextColumn({ header: '고객', field: 'customerNm', size: 110 }),
    hiCol.roTextColumn({ header: '구분', field: 'typeLabel', size: 80, align: 'center' }),
    hiCol.roTextColumn({ header: '내용', field: 'itemNm', size: 240 }),
    hiCol.roNumberColumn({ header: '금액', field: 'grossAmount', size: 100 }),
    hiCol.roNumberColumn({ header: '할인', field: 'discountAmount', size: 90 }),
    hiCol.roNumberColumn({ header: '실매출', field: 'netAmount', size: 100 }),
    hiCol.roTextColumn({ header: '결제수단', field: 'payLabel', size: 90, align: 'center' }),
    hiCol.roTextColumn({ header: '환불', field: 'refundLabel', size: 64, align: 'center' }),
  ],
  load: (tc) => {
    const customers = new Map(loadTable(tc, 'customer').map((c) => [c.customerUid, c]));
    return loadTable(tc, 'sale')
      .map((s) => ({
        ...s,
        mod: '',
        customerNm: customers.get(s.customerUid)?.customerNm || '(비회원)',
        typeLabel: label(SALE_TYPE_OPTIONS, s.saleType),
        payLabel: label(PAY_METHOD_OPTIONS, s.payMethod),
        refundLabel: s.refundYn === 'Y' ? '환불' : '',
      }))
      .sort((a, b) => String(b.saleDate).localeCompare(String(a.saleDate)));
  },
  filter: (rows, v) => rows.filter(
    (r) => inRange(r.saleDate, v.fromDate, v.toDate)
      && (!v.saleType || r.saleType === v.saleType)
      && (!v.customerUid || r.customerUid === v.customerUid)
  ),
};
const SaleReport = () => <ShopGridPage cfg={cfg} />;
export default SaleReport;
